import React from 'react';
import { Form } from '../../../ui/universe';
import { Input, Tooltip } from 'tdesign-react';

/**
 * Input 参数渲染器
 */
function InputRenderer({ params, value, showClose, placeholder, onClose, onChange }) {
  return (
    <Form.Item
      className={`${params.LabelAlign ? 'column' : 'row'}`}
      label={
        <>
          <span>{params.label}</span>
          {params.des && (
            <Tooltip content={params.des} theme="light">
              <span className="ocrDemo-icon-question"></span>
            </Tooltip>
          )}
        </>
      }
    >
      <div className="flex">
        <Input
          status={params.status}
          value={value}
          onChange={(e) => {
            onChange && onChange(e);
          }}
          placeholder={params.placeholder || placeholder}
        />
        {showClose && <i className="universe-icon univ-icon-close ml-10" onClick={onClose}></i>}
      </div>
    </Form.Item>
  );
}

export default InputRenderer;
